<template>
    <page>
        <module title="拼团活动详情">
            <div v-if="activityInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="活动名称">{{activityInfo.activity_name}}</c-detail-item>

                    <c-detail-item label="活动时间">{{activityInfo.begin_date}} - {{activityInfo.end_date}}</c-detail-item>

                    <c-detail-item label="拼团数量">{{activityInfo.group_count}}</c-detail-item>

                    <c-detail-item label="成团数量">{{activityInfo.group_success_count}}</c-detail-item>

                    <c-detail-item label="拼团有效期">{{activityInfo.valid_time}}小时</c-detail-item>

                    <c-detail-item label="参团方式">
                        <template v-slot="{data}">
                            <span v-if="activityInfo.group_product_type==1">SKU（参团只能购买相同SKU）</span>
                            <span v-if="activityInfo.group_product_type==2">商品（参团可购买不同SKU）</span>
                        </template>
                    </c-detail-item>

                    <c-detail-item label="活动标签">{{activityInfo.tags}}</c-detail-item>

                    <c-detail-item label="活动预告设置">{{activitynoticeText}}</c-detail-item>

                    <c-detail-item label="活动商品" full>
                        <c-table v-model="productList" height="auto" border>

                            <c-table-column
                                    label="商品信息"
                                    name="product_name"
                                    width="250"
                            >
                                <template v-slot="{data}">
                                    <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
                                    <product-info v-else :image="data.product_img_url" :name="data.product_name" image-size="60"></product-info>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="原价"
                                    name="product_price"
                                    width="130"
                            >
                                <template v-slot="{data}">￥{{data.product_price}}</template>
                            </c-table-column>

                            <c-table-column
                                    label="成团方式"
                                    name="group_type"
                                    width="80"
                            >
                                <template v-slot="{data}">
                                    <span v-if="data.group_type == 1" style="color:green">参团人数</span>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="成团数量"
                                    name="min_group_count"
                                    width="80"
                            >
                                <template v-slot="{data}">{{data.min_group_count}}</template>
                            </c-table-column>

                            <c-table-column
                                    label="拼团价"
                                    name="group_unit_price"
                                    width="80"
                            >
                                <template v-slot="{data}">￥{{data.group_unit_price}}</template>
                            </c-table-column>

                            <c-table-column
                                    label="活动销量(总数)"
                                    name="sale_count"
                                    width="80"
                            >
                            </c-table-column>

                            <c-table-column
                                    label="商品状态"
                                    name="state"
                                    width="80"
                            >
                                <template v-slot="{data}">
                                    <span v-if="data.state == 1" style="color:red">禁用</span>
                                    <span v-if="data.state == 2" style="color:green">启用</span>
                                </template>
                            </c-table-column>
                        </c-table>
                    </c-detail-item>
                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import productInfo from '@/components/public/product_info.vue'
    import {mapState} from 'vuex'

    export default {
        name: 'activity_group_detail',

        props: {
            id: String
        },

        components: {
            productInfo
        },

        data() {
            return {
                activityInfo: '',
                userLevelStr: '',
                userLevelArr: [],
                productList: [],
                activitynoticeText: ''
            }
        },

        computed: {
            ...mapState(['dict'])
        },

        watch: {
            id() {
                this.getActivityDetail();
            }
        },

        mounted() {
            this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activity/group/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.activityInfo = data;
                        if(data.activity_notice == 1){
                            this.activitynoticeText = '提前（'+data.activity_notice_time+'分钟）预告活动';
                        }else if(data.activity_notice == 0){
                            this.activitynoticeText = '立即预告';
                        }else if(data.activity_notice == -1){
                            this.activitynoticeText = '不预告';
                        }
                        this.productList = data.product_list;
                    }
                });
          }
        }
    }
</script>